import React, { useState } from 'react';
import './LoginPage.css';
import { apiCall } from '../config/api';

const ForgotPassword = ({ onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setError('Email is required');
      return;
    }
    
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await apiCall('/auth/forgot-password', {
        method: 'POST',
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
      } else {
        setError(data.error || 'Failed to send reset email. Please try again.');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      setError('Network error. Please check your connection and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <img 
              src={`${process.env.PUBLIC_URL}/assets/images/Aminole-Logo.png`} 
              alt="Aminole Logo" 
              className="login-logo" 
            />
            <h2>Check Your Email</h2>
            <p>We've sent a password reset link to your email address.</p>
          </div>

          <div className="success-message">
            <div className="success-icon">✉️</div>
            <p>If an account exists with <strong>{email}</strong>, you will receive an email with instructions to reset your password.</p>
            <p className="success-note">The link will expire in 1 hour.</p>
          </div>

          <div className="login-footer">
            <button 
              type="button" 
              className="link-button"
              onClick={onBackToLogin}
            >
              ← Back to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img 
            src={`${process.env.PUBLIC_URL}/assets/images/Aminole-Logo.png`} 
            alt="Aminole Logo" 
            className="login-logo" 
          />
          <h2>Forgot Password?</h2>
          <p>Enter your email address and we'll send you a link to reset your password.</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message general-error">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError('');
              }}
              className={error ? 'error' : ''}
              placeholder="Enter your email address"
              autoFocus
            />
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="login-footer">
          <button 
            type="button" 
            className="link-button"
            onClick={onBackToLogin}
          >
            ← Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
